export const siteSettings = {
  name: "CBaseHub",
  link: "https://cbasehub.live",
  email: "support@cbasehub.live",
  appLink: "https://app.cbasehub.live",
};
